// extracted by mini-css-extract-plugin
export default {"container":"bz7Y3LyQTG2TZaTRbIpH","header":"H8CJtY1DxVcpCSEnmshD","statsContainer":"HsTbA3yxDmTJPqpUemas","box":"OV7vpESf2XUP9E2Sk4e3","icon":"EsJXClzHiKL_0bCnIFEL"};